import type { Dispatch } from 'redux'
import { Cart, nativeAppHeaders } from '@ynap/api-utils'
import { delay } from '@ynap/promise-utils'
import { getDelay, getTimeout, getWatsonConfig } from '@ynap/cart-state/src/selectors/getConfig'
import { getLocale } from '@ynap/cart-state'
import { StoreState } from 'app/state/types'
import { SET_PACKAGING_OPTION_REQUEST, SET_PACKAGING_OPTION_SUCCESS, SET_PACKAGING_OPTION_ERROR } from '../constants/ActionTypes'
import wrapFetchWithJSON from './common/wrapFetchWithJSON'
import { checkRectificationOnError, checkRectificationOnSuccess } from '../actions/cartRectification'
import { checkGuestIdentityError } from './checkGuestIdentityError'
import { getAdditionalCheckoutHeaders } from '../utils/checkoutActionUtils'
import { ShoppingCart } from 'app/types/common-types'

type SetPackagingOptionResponseData = {
    orderId: string
    shoppingCart: ShoppingCart
    version: string
    resourceId: string
}

export function setPackagingOptionRequest() {
    return {
        type: SET_PACKAGING_OPTION_REQUEST,
    }
}

export function setPackagingOptionSuccess(payload: SetPackagingOptionResponseData) {
    return {
        type: SET_PACKAGING_OPTION_SUCCESS,
        payload,
    }
}

export function setPackagingOptionError(error: unknown) {
    return {
        type: SET_PACKAGING_OPTION_ERROR,
        error,
    }
}

export default function setPackagingOption(values: { packagingOption: string; giftMessage?: string; isGift: 'Y' | 'N' }, redirect: string) {
    return async (dispatch: Dispatch, getState: () => StoreState, fetch: WindowOrWorkerGlobalScope['fetch']) => {
        const state = getState()
        const watsonConfig = getWatsonConfig(state)
        const fetchJSON = wrapFetchWithJSON(fetch, getTimeout(state))
        const { langId } = getLocale(state)
        const additionalHeaders = {
            ...nativeAppHeaders(state.deviceType),
            ...getAdditionalCheckoutHeaders(state),
        }

        const packagingOption = values.packagingOption
        const isGift = values.isGift
        const giftMessage = isGift === 'Y' && values.giftMessage ? values.giftMessage : ''

        dispatch(setPackagingOptionRequest())

        const promise = fetchJSON(Cart.setPackagingOption({ isGift, giftMessage, packagingOption, ...watsonConfig, langId, additionalHeaders }))

        try {
            const data = await delay(promise, getDelay(state))
            dispatch(setPackagingOptionSuccess(data))
            checkRectificationOnSuccess(dispatch, data, redirect)
            return data
        } catch (error) {
            checkRectificationOnError(error, dispatch)
            checkGuestIdentityError(error, dispatch, state)
            dispatch(setPackagingOptionError(error))

            throw error
        }
    }
}
